import * as yup from "yup";

const getDate = (dynamicDateString) => {
  const dateTokens = dynamicDateString.split('_');
  let newDate = new Date();
  if (dateTokens.indexOf("Y") !== -1) {
    newDate.setFullYear(new Date().getFullYear() - dateTokens[dateTokens.indexOf("Y") - 1]);
  }
  if (dateTokens.indexOf("M") !== -1) {
    newDate.setMonth(new Date().getMonth() - dateTokens.indexOf("Y") - 1);
  }
  return newDate;
}

export const generateValidationSchema = (jsonSchema) => {
  let schema = {};

  jsonSchema.forEach((field) => {
    let validator = null;
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        validator = yup.string();
        if (field.validation?.required) {
          validator = validator.required("This field is required");
        }
        if (field.validation?.maxLength) {
          validator = validator.max(
            field.validation.maxLength,
            `Max length is ${field.validation.maxLength}`
          );
        }
        if (field.validation?.pattern) {
          validator = validator.matches(
            new RegExp(field.validation.pattern),
            "Invalid format"
          );
        }
        break;
      case "select":
        if (field.validation?.required)
        {
          validator = yup.string();

            validator = validator.required("A selection is required")
            .notOneOf(
              ["na"],
              "Please select an option"
            );
        }
        
        break;
      case "radio":
        // validator = yup.mixed().oneOf(
        //   field.options.map((option) => option.value),
        //   "Invalid selection"
        // );
        if (field.validation?.required) {
          validator = validator.required("A selection is required");
        }
        break;
      case "date":
        validator = yup.date();

        if (field.validation.required) {
          validator = validator.required("A date is required");
        }

        if (field.name === "dob") {
          // Add custom validation for dob to check if the user is at least 18 years old
          jsonSchema[field.name] = yup
            .string()
            .required("Birthdate is required")
            .test(
              "is-old-enough",
              "You must be at least 18 years old",
              (value) => {
                // Ensure value is defined and follows the format 'YYYY-MM-DD'
                if (!value) return false;
                const birthYear = parseInt(value.split("-")[0]);
                const currentYear = new Date().getFullYear();
                return currentYear - birthYear >= 18;
              }
            );
        }
        
        // dates are a string in ISO format "2022-02-12"
        if (field.validation.minDate) {
          validator = validator.min(
            new Date(field.validation.minDate),
            `Date must be on or after ${field.validation.minDate}`
          );
        }

        if (field.validation.maxDateDynamic) {
          const dyanamicMinDate = getDate(field.validation.maxDateDynamic);
          validator = validator.max(
            dyanamicMinDate,
            `Date must be on or before ${dyanamicMinDate}`
          );
        }

        if (field.validation.maxDate) {
          validator = validator.max(
            new Date(field.validation.maxDate),
            `Date must be on or before ${field.validation.maxDate}`
          );
        }
        break;
      default:
        console.warn(`Unhandled field type: ${field.type}`);
        break;
    }

    if (validator) {
      if (field.name === "email") {
        validator = validator.when("defaultLogin", {
          is: (defaultlogin) => defaultlogin === "1",
          then: (schema) => schema.required("This field is required"),
          otherwise: (schema) => schema,
        });
      }
      schema[field.name] = validator;
    }

    if (field.name === "peppersons") {
      validator = yup.string();
      validator = validator.when("politicallyexposed", {
        is: (pepstatus) => pepstatus === "1",
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema,
      });
      schema[field.name] = validator;
    }

  });

  // console.log(schema)

  return yup.object().shape(schema);
};
